'use client';

import React, { HTMLAttributeAnchorTarget } from 'react';

import { checkActivePathname } from '@/helpers/active-link-helper';
import { cn } from '@cineamo/ui/src/helpers/cn';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

import { Link, usePathname } from '@/i18n/routing';
import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type NavigationItemProps = {
    className?: string;
    classNameTitle?: string;
    href: string;
    target?: HTMLAttributeAnchorTarget;
    title: string;
    icon?: React.ReactNode;
    activeIcon?: React.ReactNode;
    trackClickEvent?: string;
    item?: string;
};

function NavigationItem(props: NavigationItemProps) {
    const domainConfiguration = useDomainConfiguration();
    const { track } = useAnalytics();

    const currentPath = usePathname();
    const isActive = checkActivePathname(props.href, currentPath);

    return (
        <Link
            className={cn(
                props.className,
                'cursor-pointer',
                'text-body-bold-14',
                'flex flex-row flex-none space-x-8 items-center grow-0',
                'h-48 py-8 px-[20px]'
            )}
            onClick={() => {
                if (props.item) {
                    track('Navigation Item Clicked', { item: props.item });
                }
                if (props.trackClickEvent) {
                    track(props.trackClickEvent);
                }
            }}
            target={props.target}
            href={props.href}
            /*
             * Prefetch the full page data beyond the loading.js boundaries by setting the prefetch prop to true
             * (See: https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#2-prefetching)
             */
            prefetch={false}
            style={
                domainConfiguration
                    ? {
                          color: isActive ? domainConfiguration.style.onBackgroundColor : undefined,
                          opacity: isActive ? 1 : 0.7
                      }
                    : undefined
            }>
            {isActive ? props.activeIcon : props.icon}
            {props.title && <span className={props.classNameTitle}>{props.title}</span>}
        </Link>
    );
}

export default NavigationItem;
